import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminActivate() {
  const nav = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [state, setState] = useState({ loading: true, valid: false });
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState({ loading: false, valid: false }); return; }
    api.get(`/admin/activate/validate?token=${encodeURIComponent(token)}`)
      .then(({ data }) => setState({ loading: false, valid: true, ...data }))
      .catch(() => setState({ loading: false, valid: false }));
  }, [token]);

  const submit = async () => {
    if (pw !== pw2) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/admin/activate", { token, password: pw });
      toast.success("Account activated — please sign in");
      nav("/admin/login");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#1A090D] text-[#FAF5F0] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#2A0F14] border border-[#781826]/40 rounded-2xl p-6" data-testid="admin-activate">
        <div className="font-serif font-bold text-2xl mb-1">Mana<span className="text-[#C59B27]">Jodi</span> <span className="text-xs text-[#C59B27] font-sans">Admin</span></div>
        {state.loading ? <p className="text-sm text-[#D8B4B9] mt-4">Validating your invitation…</p> :
          !state.valid ? (
            <div className="mt-4">
              <h1 className="font-serif text-xl font-bold text-rose-300">Invalid or expired link</h1>
              <p className="text-sm text-[#D8B4B9] mt-2">This invitation link is invalid or has expired. Ask your Super Admin to resend the invitation.</p>
            </div>
          ) : (
            <div className="mt-4 space-y-3">
              <h1 className="font-serif text-xl font-bold">Set your password</h1>
              <p className="text-sm text-[#D8B4B9]">Activating <b>{state.email}</b>{state.full_name ? ` (${state.full_name})` : ""}. Choose a strong password (8+ chars, letter + number).</p>
              <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" data-testid="activate-pw"
                className="w-full bg-[#1A090D] border border-[#781826]/40 rounded-lg px-3 py-2.5 text-sm" />
              <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm password" data-testid="activate-pw2"
                className="w-full bg-[#1A090D] border border-[#781826]/40 rounded-lg px-3 py-2.5 text-sm" />
              <button onClick={submit} disabled={busy} data-testid="activate-submit" className="btn-gold w-full rounded-lg py-2.5 disabled:opacity-60">
                {busy ? "Activating…" : "Activate account"}
              </button>
            </div>
          )}
      </div>
    </div>
  );
}
